module.exports = __webpack_public_path__ + "img/kr.6d3d963.svg";